import { render, staticRenderFns } from "./ConfirmationWindow.vue?vue&type=template&id=a5db56ae"
import script from "./ConfirmationWindow.vue?vue&type=script&lang=js"
export * from "./ConfirmationWindow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports